import {
    BarChart,
    Bar,
    ResponsiveContainer,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    Label,
} from "recharts";

import {
    Box,
    Text,
} from "@chakra-ui/react";

import Card from "./Card";

const CommissionTrendChart = ({
    milestones = [],
    commissions = [],
    payouts = [],
}) => {
const monthOrder = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

const monthlyData = {};

monthOrder.forEach(month => {
    monthlyData[month] = {
        milestone: 0,
        delivery: 0,
    };
});

milestones.forEach(milestone => {
    if (
        milestone.commission_status !==
        "Paid"
    ) {
        return;
    }

    const date = new Date(
        milestone.updated_at ||
        milestone.created_at
    );

    const month =
        date.toLocaleDateString(
            "en-US",
            {
                month: "short",
            }
        );

    monthlyData[month].milestone +=
        Number(
            milestone.commission_amount ||
            0
        );
});

payouts.forEach(payout => {
    if (!payout.commission_id) {
        return;
    }

    const date = new Date(
        payout.paid_at ||
        payout.created_at
    );

    const month =
        date.toLocaleDateString(
            "en-US",
            {
                month: "short",
            }
        );

    monthlyData[month].delivery +=
        Number(
            payout.amount || 0
        );
});

const data = monthOrder.map(
    month => ({
        month,
        milestone:
            monthlyData[month]
                .milestone,
        delivery:
            monthlyData[month]
                .delivery,
    })
);

    return (
        <Card>
            <Box mb={6}>
                <Text
                    fontSize="lg"
                    fontWeight="700"
                    color="#071D54"
                >
                    Earnings Trend
                </Text>

                <Text
                    color="gray.500"
                    fontSize="sm"
                >
                    Monthly milestone rewards and
    delivery commissions.
                </Text>
            </Box>

            <ResponsiveContainer
                width="100%"
                height={280}
            >
                <BarChart
                    data={data}
                    margin={{
                        top: 20,
                        right: 20,
                        left: 10,
                        bottom: 20,
                    }}
                >
                    <CartesianGrid
                        strokeDasharray="3 3"
                        vertical={false}
                        stroke="#E2E8F0"
                    />

                    <XAxis
                        dataKey="month"
                        tick={{
                            fontSize: 12,
                        }}
                    >
                        <Label
                            value="Month"
                            offset={-10}
                            position="insideBottom"
                        />
                    </XAxis>

                    <YAxis
                        tick={{
                            fontSize: 12,
                        }}
                        tickFormatter={(
                            value
                        ) =>
                            `P${value}`
                        }
                    >
                        <Label
                            value="Commission (P)"
                            angle={-90}
                            position="insideLeft"
                        />
                    </YAxis>

                    <Tooltip
                    formatter={(value, name) => [
                        `P${Number(value).toFixed(2)}`,
                        name === "milestone"
                            ? "Milestone Earnings"
                            : "Delivery Earnings",
                    ]}
                />

                   <Bar
    dataKey="milestone"
    stackId="earnings"
    fill="#2453FF"
    radius={[0, 0, 0, 0]}
/>

<Bar
    dataKey="delivery"
    stackId="earnings"
    fill="#10B981"
/>
                </BarChart>
            </ResponsiveContainer>
        </Card>
    );
};

export default CommissionTrendChart;